import React from 'react'
import VFooter from './VFooter'
import Top from './Top'
import { Card } from './ui';

export default function ReturnPolicy() {
  return (
    <div>
      <Top/>
      <section className="py-8 px-3 mt-20 bg-[#f4ece5] text-[#333] font-sans">
      <div className="max-w-4xl mx-auto bg-white p-10 rounded-lg shadow-md">
        <h2 className="text-center mb-8 text-3xl font-bold">Return/Refund & Exchange Policy</h2>
        
        <div className="space-y-10">
          <div>
            <p className="text-xl font-bold mb-4">Return Policy:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>No Returns Accepted:</strong> Due to the custom nature of the designs offered on Vasstr, 
                all sales are final. We do not accept returns once an order is confirmed.
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xl font-bold mb-4">Refund Policy:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>No Refunds:</strong> All transactions are final, and we do not provide refunds once 
                payment has been processed.
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xl font-bold mb-4">Exchange Policy:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>No Exchanges Permitted:</strong> We do not allow exchanges for items once ordered. 
                This policy helps ensure the value of your unique designs.
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xl font-bold mb-4">Customer Satisfaction:</p>
            <ul className="list-disc pl-5 space-y-4">
              <li>
                <strong>Quality Assurance:</strong> While we do not accept returns or offer refunds, 
                we encourage you to maintain high-quality standards to ensure customer satisfaction.
              </li>
              <li>
                <strong>Feedback Mechanism:</strong> Users can leave feedback about their experience and 
                the quality of the products they receive. This feedback will help future customers make 
                informed decisions.
              </li>
              <li>
                <strong>Communication:</strong> If a user has concerns about their order, good communication 
                between you and the user can help resolve issues and maintain a positive relationship.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
      <VFooter/>
    </div>
  )
}
